var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6784 11.3151C14.1683 12.7719 13.2104 14.0219 11.9473 14.8789C10.6842 15.736 9.1834 16.1544 7.66826 16.0718C6.15312 15.9893 4.70463 15.4102 3.53834 14.4207C2.37205 13.4312 1.55032 12.0843 1.19541 10.5803C0.840511 9.07637 0.971416 7.49578 1.56865 6.07378C2.16588 4.65178 3.19752 3.46438 4.51003 2.68829C5.82254 1.91219 7.34577 1.58889 8.85304 1.76649C10.3603 1.9441 11.771 2.61311 12.8753 3.67397",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1.52002L10.2007 5.23028L14.417 5.82159L15 1.52002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.eed8556481681200e98ee6b412123e79.svg";
export { ForwardRef as ReactComponent };